const showPassworLabel = "Mostra password";
const hidePassworLabel = "Nascondi password";
export default {
  data() {
    return {
      passwordInputType: {
        old: "password",
        new: "password",
      },
      switchPWdLabel: {
        old: showPassworLabel,
        new: showPassworLabel,
      },
    };
  },
  methods: {
    switchPwdType(kind) {
      if (this.passwordInputType[kind] === "password") {
        this.passwordInputType[kind] = "text";
        this.$set(this.switchPWdLabel, kind, hidePassworLabel);
      } else {
        this.passwordInputType[kind] = "password";
        this.$set(this.switchPWdLabel, kind, showPassworLabel);
      }
    },
  },
};
